// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "hashed-1/" + (chunkId === 20071 ? "griffel" : chunkId) + "-" + {20071: "994da4257d",47577: "81d35eec74",75434: "52714c4833",86833: "42ef90fcb1",}[chunkId] + ".css"
}